import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const RainbowBurstAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number,
  clampX: (x: number) => number,
  clampY: (y: number) => number,
  globalHue: number
) => {
  const useRGB = config.rgbLighting && config.useFXRGB && !config.blastMatchRingColor;
  for(let i=0; i<24; i++){
    if (useRGB) ctx.strokeStyle = `hsl(${(i * 15 + globalHue)%360}, 100%, 50%)`;
    ctx.beginPath();
    const rBase = e.maxRadius + progress * 150;
    const ang = (i/24)*Math.PI*2;
    const r = getRadiusAtAngle(ang, e, rBase);
    const cx = e.pos.x;
    const cy = e.pos.y;
    ctx.arc(cx, cy, r, (i/24)*Math.PI*2, ((i+0.5)/24)*Math.PI*2);
    ctx.lineWidth = 15 * (1-progress);
    ctx.stroke();
  }
};

registerBlastAnimation('RAINBOW_BURST', RainbowBurstAnimation);
